/* eslint-disable jsx-a11y/anchor-is-valid */
import "./styles/RecipientSelector.scss";
import React, { Component } from "react";
import Loading from "./Loading";
import { listRecipients } from "../api/recipients";

export default class RecipientGroupSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recipients: undefined,
      selectedRecipients: this.props.existingRecipients,
      filter: undefined,
    };
  }

  componentDidMount() {
    listRecipients().then((res) => this.setState({ recipients: res }));
  }

  selectedCount = () => {
    return this.state.selectedRecipients.length;
  };

  render() {
    const renderIndividualLine = (type, data) => {
      const isInRecipients = () => {
        if (this.state.selectedRecipients.includes(data.id)) return true;

        return false;
      };

      const ToggleRecipients = () => {
        if (!isInRecipients()) {
          this.setState({
            selectedRecipients: [...this.state.selectedRecipients, data.id],
          });
        } else {
          this.setState({
            selectedRecipients: this.state.selectedRecipients.filter(
              (g) => g !== data.id
            ),
          });
        }
      };

      return (
        <div className="field" onClick={() => ToggleRecipients()} key={data.id}>
          <input
            id={data.id}
            type="checkbox"
            name={data.name}
            className="switch"
            checked={isInRecipients()}
            onChange={() => {}}
          />
          <label>{data.name}</label>
        </div>
      );
    };

    const renderIndividual = () => {
      if (!this.state.recipients) {
        return (
          <div className="main-rec-container mt-4 mb-4 is-flex is-justify-content-center">
            <Loading />
          </div>
        );
      }

      const inEntries = this.state.recipients.individual
        .filter((i) => this.state.selectedRecipients.includes(i.id))
        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
      const outEntries = this.state.recipients.individual
        .filter((i) => !this.state.selectedRecipients.includes(i.id))
        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

      const entries = [...inEntries, ...outEntries];

      const filter = this.state.filter;
      const rows = filter
        ? entries.filter(
            (r) =>
              r.name.toLowerCase().includes(filter.toLowerCase()) ||
              r.phone.includes(filter)
          )
        : entries;

      return (
        <>
          <p>Select employees to include in this group.</p>

          <input
            className="input mt-2 mb-2"
            type="text"
            placeholder="Filter by name or phone #"
            onChange={(e) => this.setState({ filter: e.target.value })}
          />

          <div className="main-rec-container mt-2 mb-4">
            <div className="field">
              {rows.map((g) => renderIndividualLine("individual", g))}
            </div>
          </div>
        </>
      );
    };

    return (
      <div className="box recipient-selector">
        <div className="">
          <label className="label mb-4">Recipients</label>

          {renderIndividual()}

          {this.state.recipients && (
            <>
              <label className="label mb-4">
                {this.selectedCount()} recipients selected
              </label>
            </>
          )}

          <div className="buttons mt-4">
            <button
              className="button is-primary is-small"
              onClick={() => {
                this.props.onConfirm(this.state.selectedRecipients);
                this.props.onClose();
              }}
            >
              Save
            </button>
            <button
              className="button is-info is-small"
              onClick={() => this.props.onClose()}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }
}
